import { render, staticRenderFns } from "./OrdenesServicio.vue?vue&type=template&id=f02e37ec&scoped=true"
import script from "./OrdenesServicio.vue?vue&type=script&lang=js"
export * from "./OrdenesServicio.vue?vue&type=script&lang=js"
import style0 from "./OrdenesServicio.vue?vue&type=style&index=0&id=f02e37ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02e37ec",
  null
  
)

export default component.exports